import type { TBlock } from 'stores/fieldAssetStore/helperTypes'
import { captureFrontendError } from 'utils/captureFrontendError'

const isNestedLatLngArray = (values: unknown[]): values is number[][] => {
  return !(values.length === 2 && typeof values[0] === 'number' && typeof values[1] === 'number')
}

export const makeBlockBounds = (
  map: google.maps.Map,
  propertyBlocks: {
    [blockId: string]: TBlock
  },
  centroidCoordinates?: {
    lat: number
    lng: number
  },
) => {
  try {
    Object.values(propertyBlocks).forEach((block: TBlock) => {
      const { geometry: polygonString } = block

      const { coordinates } = JSON.parse(polygonString) as {
        coordinates: Array<Array<number[] | Array<number[]>>>
      }

      const blockBounds = new google.maps.LatLngBounds()

      const blockLatLngs = coordinates[0].reduce((all, values) => {
        if (!isNestedLatLngArray(values)) {
          const [lng, lat] = values

          blockBounds.extend({ lat, lng })

          all.push(new google.maps.LatLng({ lat, lng }))
        } else {
          const latLngs = values.map(([lng, lat]) => {
            blockBounds.extend({ lat, lng })

            return new google.maps.LatLng({ lat, lng })
          })

          all.push(...latLngs)
        }

        return all
      }, [] as google.maps.LatLng[])

      const polygon = new google.maps.Polygon({ paths: blockLatLngs, map })

      polygon.setOptions({
        strokeColor: 'white',
        strokeWeight: 2,
        fillColor: 'none',
      })

      if (centroidCoordinates) {
        const { lng, lat } = centroidCoordinates

        new google.maps.Marker({
          position: { lat, lng },
          map,
        })
      }
    })
  } catch (err) {
    captureFrontendError(err)
  }
}
